import { FileCheck, UserPlus, Globe, Users, ShieldAlert, Kanban, Mail, MessageSquare, Bell, LayoutTemplate, Tag, ListTodo, Clock, GitBranch } from "lucide-react";

export const TRIGGERS = [
  { type: "form_submitted", label: "Form submitted", desc: "When someone submits one of your forms", icon: FileCheck, group: "Forms & website" },
  { type: "referral_created", label: "Referral created", desc: "When a referral lands in Contacts › Referrals (from a form or website enquiry)", icon: UserPlus, group: "Forms & website" },
  { type: "website_enquiry", label: "Website enquiry converted", desc: "When a BOS HQ website enquiry is turned into a referral for this entity", icon: Globe, group: "Forms & website" },
  { type: "contact_created", label: "Contact created", desc: "When a new contact is added", icon: Users, group: "Other" },
  { type: "incident_created", label: "Incident created", desc: "When an incident is reported", icon: ShieldAlert, group: "Other" },
  { type: "opportunity_stage_changed", label: "Opportunity stage changed", desc: "When an opportunity moves stage", icon: Kanban, group: "Other" },
];

export const ACTIONS = [
  { type: "internal_notification", label: "Internal notification", desc: "Email or text someone other than the contact", icon: Bell, group: "Messages" },
  { type: "send_email", label: "Send email", desc: "Email the contact who triggered this", icon: Mail, group: "Messages" },
  { type: "send_sms", label: "Send SMS", desc: "Text the contact who triggered this", icon: MessageSquare, group: "Messages" },
  { type: "send_email_template", label: "Send email template", desc: "Send one of your saved custom emails", icon: LayoutTemplate, group: "Messages" },
  { type: "add_tag", label: "Add tag", desc: "Tag the linked contact", icon: Tag, group: "Contact" },
  { type: "create_task", label: "Create task", desc: "Add a task for the team", icon: ListTodo, group: "Tasks" },
  { type: "wait", label: "Wait", desc: "Pause for a set time, or until a sensible hour (no 3am texts)", icon: Clock, group: "Logic" },
  { type: "if_else", label: "If / else", desc: "Check one answer and split into Yes and No paths", icon: GitBranch, group: "Logic" },
];

export const OPS = [["equals", "is"], ["not_equals", "is not"], ["contains", "contains"], ["not_contains", "doesn't contain"], ["empty", "is empty"], ["not_empty", "is not empty"]];
export const opLabel = (o) => (OPS.find((x) => x[0] === o) || OPS[0])[1];

export function stepSummary(s) {
  const c = s.config || {};
  if (s.type === "wait") {
    const d = Number(c.amount) > 0 ? `Wait ${c.amount} ${c.unit || "minutes"}` : "No delay";
    return c.window ? `${d}, then only ${c.start || "09:00"}–${c.end || "19:00"}${c.weekdays ? " Mon–Fri" : ""}` : d;
  }
  if (s.type === "if_else") return c.field ? `If ${c.field} ${opLabel(c.op)}${["empty", "not_empty"].includes(c.op) ? "" : ` "${c.value || ""}"`}` : "Choose what to check";
  if (s.type === "create_task" || s.type === "add_tag") return c.value || "";
  return "";
}

export const newStep = (type) => ({ type, name: findA(type).label,
  config: type === "internal_notification" ? { channel: "email", to_type: "users" } : type === "wait" ? { amount: 1, unit: "hours", window: true, start: "09:00", end: "19:00" } : type === "if_else" ? { op: "equals" } : {},
  ...(type === "if_else" ? { yes: [], no: [] } : {}) });

export function getList(steps, path) {
  let list = steps;
  for (let k = 0; k < path.length; k += 2) list = list[path[k]][path[k + 1]] || [];
  return list;
}

export function setList(steps, path, next) {
  if (!path.length) return next;
  const [i, br, ...rest] = path;
  return steps.map((s, j) => (j === i ? { ...s, [br]: setList(s[br] || [], rest, next) } : s));
}

export const MERGE = ["first_name", "last_name", "email", "phone", "form_name", "source"];
export const findT = (t) => TRIGGERS.find((x) => x.type === t) || TRIGGERS[0];
export function findA(t) { return ACTIONS.find((x) => x.type === t) || ACTIONS[0]; }

const LEGACY = { send_email_alert: "email", send_sms_alert: "sms" };

export function normalise(wf) {
  const triggers = wf.triggers || (wf.trigger ? [{ type: wf.trigger, form_ids: wf.trigger_ref ? [wf.trigger_ref] : [] }] : []);
  const steps = wf.steps || (wf.actions || []).map((a) => (LEGACY[a.type]
    ? { type: "internal_notification", name: "Internal notification", config: { channel: LEGACY[a.type], to_type: "custom", custom: a.value || "" } }
    : { type: a.type, name: findA(a.type).label, config: { value: a.value || "", template_id: a.template_id, to_contact: a.to_contact } }));
  return { active: false, ...wf, triggers, steps };
}

export function triggerSummary(t, forms) {
  if (t.type !== "form_submitted") return findT(t.type).desc;
  const names = (t.form_ids || []).map((id) => forms.find((f) => f.id === id)?.name).filter(Boolean);
  return names.length ? `Form is any of "${names.join('", "')}"` : "Any form";
}
